import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { usePoll } from 'shared/hooks/usePoll'

import { loadFeatureFlags } from 'features/settings/actions'

export const FeatureFlagsPolling = () => {
  const dispatch = useDispatch()

  const handleGetFeatureFlags = useCallback(async () => {
    dispatch(loadFeatureFlags())
  }, [dispatch])

  usePoll(handleGetFeatureFlags, { delay: 60 })

  return null
}
